/**
 * [Phase 2c-B §4.2] OnDeckIndicator - shows the next two pickers ("ON DECK" + "IN HOLE").
 */
import React from "react";
import ManagerName from "../ManagerName";

function computePickerAtOffset(draftState, offset) {
  if (!draftState) return null;
  const teamCount = draftState?.draft_order?.length || 0;
  if (!teamCount) return null;
  const totalPicks = (draftState?.team_count || teamCount) * (draftState?.roster_size || 14);
  const nextGlobal = (draftState?.total_picks_made || 0) + offset + 1;
  if (nextGlobal > totalPicks) return null;
  const round = Math.floor((nextGlobal - 1) / teamCount) + 1;
  const pickInRound = ((nextGlobal - 1) % teamCount) + 1;
  const idx = round % 2 === 1 ? pickInRound - 1 : teamCount - pickInRound;
  const teamId = draftState.draft_order[idx];
  return teamId ? draftState.managers?.[teamId] : null;
}

export default function OnDeckIndicator({ draftState, isDark }) {
  const onDeck = computePickerAtOffset(draftState, 1);
  const inHole = computePickerAtOffset(draftState, 2);
  const cardBg = isDark ? "#1C1C1C" : "#FFFFFF";
  const border = isDark ? "#252525" : "#D8D8D8";
  const muted = isDark ? "#888" : "#666";
  const name = isDark ? "#F5F5F5" : "#0A0A0A";

  if (!onDeck && !inHole) return null;

  return (
    <div
      className="rounded-xl border p-3 space-y-2"
      style={{ background: cardBg, borderColor: border }}
      data-testid="on-deck-indicator"
    >
      {onDeck && (
        <div className="flex items-center justify-between" data-testid="on-deck-row">
          <span className="font-display font-black text-[10px] uppercase tracking-widest" style={{ color: muted }}>
            On Deck
          </span>
          <span className="font-display font-bold text-sm" style={{ color: name }}>
            <ManagerName name={onDeck.team_name || onDeck.first_name} isBot={!!onDeck.is_bot} iconSize={11} testId="on-deck-name" />
          </span>
        </div>
      )}
      {inHole && (
        <div className="flex items-center justify-between" data-testid="in-hole-row">
          <span className="font-display font-black text-[10px] uppercase tracking-widest" style={{ color: muted }}>
            In the Hole
          </span>
          <span className="font-display font-bold text-xs" style={{ color: muted }}>
            <ManagerName name={inHole.team_name || inHole.first_name} isBot={!!inHole.is_bot} iconSize={10} testId="in-hole-name" />
          </span>
        </div>
      )}
    </div>
  );
}
